// extracted by mini-css-extract-plugin
export default {"coin":"KfcO-gP7Re1UiqpkuxAwCQ==","noColors":"tRaaEkh8Q7Isut9vjB6MEA==","icon":"_589rHWpJne-AIRn+EYOniQ==","letter":"Eo1eRo8YWltISLgEHfvj2g=="};